// extracted by mini-css-extract-plugin
module.exports = {"textDivider":"index_textDivider_1RSYF","textDividerContent":"index_textDividerContent_2-c6c"};